(function ($, once) {
  Drupal.behaviors.formTypeCheckbox = {
    attach: function (context, settings) {
      $(".container-condition", context).addClass("js-flyout-active");

      let checkboxCollection = once("js-checkbox-added", ".js-form-type-checkbox label", context);
      let checkRespFiscal = $("input.resp_fiscal");

      $(checkboxCollection).each(function () {
        let label = $(this),
          checkbox = label.prev(),
          checkedParent = checkbox.parent();
        // checked = checkbox.is(':checked');

        if (label.hasClass("form-required")) {
          let required = '<span class="js-required">*</span>';

          label.append(required);
        }

        if (checkbox.is(":checked")) {
          checkbox.addClass("js-checked");
        }

        label.click(function () {
          if (checkbox.hasClass("js-checked")) {
            checkbox.removeClass("js-checked");
          } else {
            checkbox.addClass("js-checked");
          }
        });
      });
      $("input[name=address]").attr("maxLength", "60");
      $("input[name=address]").on("keyup", function () {

        const lengthVal = $(this).val();

        if (lengthVal.length > 0 ) {
          $("select[name=department]")
          .css("border-color", "red")
          .attr("required", "required");
          $(".form-item-department select").addClass("form-required");
          $("select[name=city]")
          .css("border-color", "red")
          .attr("required", "required");
          $(".form-item-city select").addClass("form-required");
          $(".form-item-city").removeClass("hide");

        } else {
          $("select[name=department]")
          .css("border-color", "#25B0AF")
          .removeAttr("required");
          $(".form-item-department select").removeClass("form-required");
          $("select[name=city]")
          .css("border-color", "#25B0AF")
          .removeAttr("required");
          $(".form-item-city select").removeClass("form-required");
          $(".form-item-city").addClass("hide");
        }

        if(lengthVal == ""){
          $("select[name=department]")
          .css("border-color", "#25B0AF")
          .removeAttr("required");
          $(".form-item-department select").removeClass("required");
          $("select[name=department]").attr("aria-required","false");

          $("select[name=city]")
          .css("border-color", "#25B0AF")
          .removeAttr("required");
          $(".form-item-city select").removeClass("required");
          $("select[name=city]").attr("aria-required","false")
        }

      });

      //jv change
      $(document).on("change", function(){
        if(checkRespFiscal[0] != null){
          checkRespFiscal.each((i, j)=> {
            if($("select[name=city]").val() !== "Ciudad" && $(j).hasClass("js-checked")){
              $(".step-4.btn-siguiente input").removeAttr("disabled");
            } else {
              $(".step-4.btn-siguiente input").attr("disabled");
            }
          })

        }
      })

      $(".field-check-com input").removeClass("field-check-com");
      //condicion primeros check
      $(".field-check-com .form-item input").on("click", function () {
        $(".field-check-com .form-item input").each(function () {
          if ($(".field-check-com .form-item input").hasClass("js-checked")) {
            $(".form-item-check-contact input")
              .attr("disabled", "disabled")
              .addClass("disabled-js-checked");
            $(".form-item-check-contact label")
              .attr("disabled", "disabled")
              .addClass("disabled-label")
              .css("color", "#BABABA");
          } else {
            $(".form-item-check-contact input").removeAttr(
              "disabled",
              "disabled"
            );
            $(".form-item-check-contact label")
              .removeAttr("disabled", "disabled")
              .removeClass("disabled-label")
              .css("color", "#000");
          }
        });
      });
      //condicion ultimo check
      $(".form-item-check-contact input").on("click", function () {
        $(".form-item-check-contact input").each(function () {
          if ($(".form-item-check-contact input").hasClass("js-checked")) {
            $(".field-check-com .form-item input")
              .attr("disabled", "disabled")
              .addClass("disabled-js-checked");
            $(".field-check-com .form-item label")
              .attr("disabled", "disabled")
              .addClass("disabled-label")
              .css("color", "#BABABA");
          } else {
            $(".field-check-com .form-item input").removeAttr(
              "disabled",
              "disabled"
            );
            $(".field-check-com .form-item label")
              .removeAttr("disabled", "disabled")
              .removeClass("disabled-label")
              .css("color", "#000");
          }
        });
      });

    },
  };

  $("select").on("change", function () {
    const indiceVal = $(this).val();
    document.getElementById("edit-next").disabled = true;
    $("input[name=number_document]").on("keyup", function (e) {
      var montoInicial = $(this).val();

      $('.form-item-number-document').removeClass('hide-error');

      if (indiceVal == "2") {
        if(montoInicial.length >= 4 && montoInicial.length <= 8){
          $(".form-text").css("border-color", "#25B0AF");
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = false;
        }
        else if(montoInicial.length === 9){
          $(".form-text").css("border-color", "red");
          $(".form-text").parent().addClass("error-9")
          document.getElementById("edit-next").disabled = true;
        }else if(montoInicial.length === 10){
          $(".form-text").css("border-color", "#25B0AF");
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = false;

        }else{
          $(".form-text").css("border-color", "red")
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = true;
        }
      } else if (indiceVal == "3") {
        montoInicial.length >= 6 && montoInicial.length <= 7
          ? $(".form-text").css("border-color", "#25B0AF")
          : $(".form-text").css("border-color", "red");
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = false;

      } else if (indiceVal == "4") {
        montoInicial.length >= 1 && montoInicial.length <= 15
          ? $(".form-text").css("border-color", "#25B0AF")
          : $(".form-text").css("border-color", "red");
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = false;

      } else if (indiceVal == "6") {
        if (montoInicial.length === 9 || montoInicial.length === 11) {
          $(".form-text").css("border-color", "#25B0AF");
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = false;
        }else if(montoInicial.length === 10){
          $(".form-text").css("border-color", "red !important");
          $(".form-text").parent().addClass("error-9");
          $(".form-text").parent().removeClass("valid");
          document.getElementById("edit-next").disabled = true;
        }
      } else if (indiceVal == "7") {
        montoInicial.length === 7
          ? $(".form-text").css("border-color", "#25B0AF")
          : $(".form-text").css("border-color", "red");
          $(".form-text").parent().removeClass("error-9");
          document.getElementById("edit-next").disabled = false;
      }
    });
  });

})(jQuery, once);
